/**
 * Product tags/icons for sustainability features and certifications
 */
const ProductTags = ({ productExtras, fullClaimFootnoteText }) => {
  if (!productExtras || productExtras.filter((item) => item !== null).length === 0) {
    return null;
  }

  const filteredExtras = productExtras.filter((item) => item !== null);

  return (
    <div className="pdp-header__product-tags-wrapper">
      {filteredExtras.map((item, index) => (
        <div key={`product-tag__${index}`} className="pdp-header__product-tag">
          <span className={`pdp-header__product-tag-icon ${item.iconClass}`}></span>
          <span className="pdp-header__product-tag-name">{item.label}</span>
        </div>
      ))}
      {fullClaimFootnoteText && (
        <div className="pdp-header__product-tags-more-message-wrapper">
          <span className="pdp-header__product-tags-more-message">{fullClaimFootnoteText}</span>
        </div>
      )}
    </div>
  );
};

export default ProductTags;
